 <section id="container" [ngClass]="{'sidebar-closed': sideNavService.hideSideNav }">
  <!--header start-->
  <app-header></app-header>
  <!--header end-->
  <!--sidebar start-->
  <app-sidemenu></app-sidemenu>
  <!--sidebar end-->
  <!--main content start-->
  <section id="main-content">
    <section class="wrapper">
      <!-- page start-->
      <div class="row">
        <div class="col-lg-12">
          <ul class="breadcrumb">
            <li><a href="#"><i class="fa fa-home"></i> Home</a></li>
            <li><a href="#">All Orders</a></li>
          </ul>
        </div>
        
      </div>
      <div class="row">
        <div class="col-lg-12">
          <section class="panel">
            <header class="panel-heading">
              Search
            </header>
            <div class="panel-body">
              <div class="col-sm-10 ">
                <div  class="form-inline" role="form">
                  <form class="form_search"  #ngForm="ngForm" [formGroup]="searchForm" (ngSubmit)="searchsubmit()">
                    <div class="form-group col-sm-3 datecontainer">
                      <mat-form-field  appearance="fill">
                       <label class="sr-only" for="exampleInputEmail2">Start Date</label>
                       <input readonly class="form-control" formControlName="start_date"  matInput [matDatepicker]="picker" placeholder="Start Date">
                       <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                       <mat-datepicker #picker ></mat-datepicker>
                     </mat-form-field>
                    </div>
                    <div class="form-group col-sm-3 datecontainer">
                     <mat-form-field  appearance="fill">
                       <label class="sr-only" for="exampleInputEmail2">End Date</label>
                       <input readonly class="form-control" formControlName="end_date"  matInput [matDatepicker]="picker2" placeholder="End Date">
                       <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                       <mat-datepicker #picker2 ></mat-datepicker>
                     </mat-form-field>
                    </div>
                    <div class="form-group col-sm-2">
                      <button [ngClass]="{'disabled': !searchForm.valid}" type="submit" class="btn btn-primary searchbtn">Search</button>
                    </div>
                 </form>
               </div>
             </div>  
           </div>
         </section>
       </div>
     </div>
     <div class="row">
      <div class="col-lg-12">
       
        <section class="panel">
          <div class="panel-body">
            <div class="col-sm-4 "><button type="submit" (click)="submitdelForm()" class="btn btn-primary ">Delete Selected</button></div>
            <div class="col-sm-4">
              <label class="col-sm-8 control-label col-lg-8" for="inputSuccess" style="
              text-align: right; margin-top: 7px;
              ">Records Per Page</label>
              <div class="col-sm-4">
                <select class="form-control m-bot0" #perpageSelect (change)='onperpageSelected(perpageSelect.value)'>
                  <option [attr.selected]="per == per_page ? true : null" *ngFor="let per of per_values">{{per}}</option>
                  
                </select>
              </div>
            </div>
            <div class="col-sm-4">
              <ul class="pagination pagination-sm pull-right" *ngIf="!(pages.length <= 1)" style="margin:0">
                <li [class.disabled]="isFirstPage()" ><a style= "cursor: pointer"(click)="ChangePage(previouspage)" *ngIf="1 <getCurrent()" >«</a><span *ngIf="isFirstPage()">«</span></li>
                
                <li [class.current]="getCurrent() === page.value" 
                [class.ellipsis]="page.label === '...'" *ngFor="let page of pages"><a style= "cursor: pointer"(click)="ChangePage(page.value)"  *ngIf="getCurrent() !== page.value">{{ (page.label === '...') ? page.label : (page.label | number:'') }}</a>
                <span *ngIf="getCurrent() === page.value">
                  
                 {{ (page.label === '...') ? page.label : (page.label | number:'') }}
               </span>         
             </li>
             
             <li [class.disabled]="isLastPage()" ><a *ngIf="!isLastPage()" style= "cursor: pointer"(click)="ChangePage(nextpage)" >»</a>
              
              <span *ngIf="isLastPage()">»</span>
            </li>
          </ul>
        </div>
      </div>
      
    </section>   
    <section class="panel">
      <div *ngIf="is_orders_loading"  class="d-flex justify-content-center loader-container">
        <div class="spinner-border m-5" style="color:#2964a2" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
      <table *ngIf="is_orders_loaded && !is_orders_loading" class="table table-striped table-advance table-hover table-orders">
        <thead>
          <tr>
            <th style="vertical-align:middle;">
              <label class="ckcontainer">
                <input type="checkbox" value="1" [(ngModel)]="isMasterSel" (change)="checkUncheckAll()" />
                <span class="checkmark"></span>
              </label>
            </th>
            <th>#</th>
            <th>Signed Status</th>
            <th>Signed Date</th>
            <th>Created Date</th>
            <th>Order Id</th>
            <th>Client's Name</th>
            <th>Company Name</th>
            <th>Client's Email</th>
            <th>Download</th>
            <th>View</th>
            <th>Edit</th>    
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let orderData of ordersData | keyvalue">
            <td width="1%" style="vertical-align:top;">
              <label class="ckcontainer">
                <input type="checkbox" [value]="orderData.value.id"  [(ngModel)]="orderlistck[orderData.key].checked" (change)="onCheckboxChange($event)" />
                <span class="checkmark"></span>
              </label>    
            </td>
            <td width="5%">{{orderData.value.id}}</td>
            <td width="7%">{{orderData.value.status}}</td>
            <td width="10%">{{orderData.value.date_time}}</td>
            <td width="8%">{{orderData.value.date}}</td>
            <td width="8%"><a href="order-details/{{orderData.value.verify_code}}">{{orderData.value.order_number}}</a></td>
            <td width="12%">{{orderData.value.name}}</td>
            <td width="12%">{{orderData.value.company_name}}</td>
            <td width="12%">{{orderData.value.email}}</td>
            <td width="2%">
              <a *ngIf="orderData.value.status=='Signed'" target=_blank href="https://www.seotunersorders.com/webapis/uploads/pdf/ORDER_{{orderData.value.order_number}}.pdf" class="btn btn-success btn-xs"><i class="fa fa-download"></i></a>
            </td>
            <td width="2%"><a href="order-details/{{orderData.value.verify_code}}" class="btn btn-primary btn-xs"><i class="fa fa-eye"></i></a></td>
            <td width="2%"><a *ngIf="orderData.value.status!='Signed'" href="order-edit/{{orderData.value.id}}" class="btn btn-success btn-xs"><i class="fa fa-pencil"></i></a></td>
          </tr>
          
          
        </tbody>
      </table>
      
    </section>
    
    
  </div>
</div>

<!-- page end-->
</section>
</section>
<!--main content end-->
<!-- Right Slidebar start -->

<!-- Right Slidebar end -->
<!--footer start-->
<app-footer></app-footer>
<!--footer end-->
</section>